// extracted by css-extract-rspack-plugin
export default {"breadcrumbs":"TableBreadcrumbs-module__breadcrumbs___mZXF9","breadcrumb":"TableBreadcrumbs-module__breadcrumb___e8A4L"};